import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

const NumberedTipsList = ({ tips = [] }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      {tips.map((tip, index) => (
        <Box key={tip.titleKey}>
          <Typography
            sx={{
              fontSize: "13px",
              fontWeight: 700,
              color: "text.primary",
              lineHeight: 1.4,
              marginBottom: "6px",
            }}
          >
            {`${index + 1} · ${t(tip.titleKey)}`}
          </Typography>
          <Typography
            sx={{
              fontSize: "13px",
              color: "text.secondary",
              lineHeight: 1.6,
              whiteSpace: "pre-line",
            }}
          >
            {t(tip.descriptionKey)}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default NumberedTipsList;
